var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"secondary fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"6"}},[(_vm.reset)?_c('reset-password'):_c('change-password')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }